import JSONRenderer from '@components/JSONRenderer'
import nanoid from '@utils/random'
import { AdSlide } from '@widgets/Gallery/types'
import { FunctionComponent, memo, useEffect, useState } from 'react'
import { StyledWrapper as AdInnerWrapper } from '@components/Ad/Wrapper'

import styled, { css } from 'styled-components'
import { desktopCSS } from '@measures/responsive'

type GalleryAdSlideProps = {
  adSlide: AdSlide
  galleryUUID: string
  index: number
  isActive: boolean
}

const GalleryAdSlideWrapper = styled.div`
  ${({
    theme: {
      colors: { staticWhite, staticBlack },
    },
  }) => css`
    width: 100%;
    height: 100%;
    display: grid;
    justify-items: center;
    align-items: center;
    background-color: ${staticBlack};
    ${desktopCSS(css`
      background-color: ${staticWhite};
    `)}

    //! This is very important to be here, otherwise the ad container will initially
    //! have a width of 0, which can hurt viewability metrics.
    > ${AdInnerWrapper} {
      width: 100%;
      text-align: center;
    }
  `}
`

const GalleryAdSlide: FunctionComponent<GalleryAdSlideProps> = (props) => {
  const { adSlide, galleryUUID, index, isActive } = props
  const [adKey, setAdKey] = useState<string>('')

  useEffect(() => {
    if (isActive) {
      setAdKey(nanoid())
    } else {
      setAdKey('')
    }
  }, [isActive])

  return (
    <GalleryAdSlideWrapper>
      {isActive && adKey && (
        <JSONRenderer key={adKey}>
          {{
            ...adSlide,
            autoLoadSlot: true,
            containerId: `${galleryUUID}-${index}-${adKey}`,
          }}
        </JSONRenderer>
      )}
    </GalleryAdSlideWrapper>
  )
}

const MemoizedGalleryAdSlide = memo(GalleryAdSlide)

MemoizedGalleryAdSlide.displayName = 'MemoizedGalleryAdSlide'

export default MemoizedGalleryAdSlide
